import { render, staticRenderFns } from "./SettingsPushNotificationsModal.vue?vue&type=template&id=350ffc9e&scoped=true&"
import script from "./SettingsPushNotificationsModal.vue?vue&type=script&lang=js&"
export * from "./SettingsPushNotificationsModal.vue?vue&type=script&lang=js&"
import style0 from "./SettingsPushNotificationsModal.vue?vue&type=style&index=0&id=350ffc9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350ffc9e",
  null
  
)

export default component.exports